import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type FeatureCategoryTitleClass = 'title';

const featureCategoryTitleStyles = makeStyles<ISpcTheme, FeatureCategoryTitleClass>(
  ({ palette, typography }) => ({
    title: {
      color: palette.text.primary,
      display: 'block',
      fontWeight: 'bold',
      fontSize: typography.fontSM,
      textTransform: 'uppercase',
    },
  }),
  { name: 'Customise_Feature_Category_Title' },
);

export default featureCategoryTitleStyles;
